import $ from "jquery";

function selectPage(container: JQuery<HTMLElement>, page: number) {
    const url = container.data("pagination-url") + "&page=" + page;

    // please entire html element with content from response
    $.post(url, function (response: string) {
        container.replaceWith(response);
    }).catch(console.error);

    window.history.pushState("", "", "?page=" + page);
}

$(function () {
    $(document).on("click", "a[data-pagination-page]", function (e: JQuery.Event) {
        const $element = $(this as HTMLElement);
        const page = Number($element.data("pagination-page"));
        const container = $element.parents("[data-pagination-url]");

        if (container.length > 0) {
            e.preventDefault();
            e.stopImmediatePropagation();

            selectPage(container, page);
        }
    });

    $(document).on("change", "select[data-pagination-select]", function () {
        const $element = $(this as HTMLSelectElement);
        const page = Number($element.val());

        const container = $element.parents("[data-pagination-url]");

        // If we have a container, we are using server side pagination with Ajax call
        if (container.length > 0) {
            selectPage(container, page);
        } else {
            // without container, we are're just redirecting to the selected page

            // get the query parameters from the current url
            const urlParams = new URLSearchParams(window.location.search);

            // remove the page parameter
            urlParams.delete("page");

            // add the new page parameter
            urlParams.append("page", page.toString());

            // redirect to the new url
            const newUrl = window.location.pathname + "?" + urlParams.toString();
            window.location.href = newUrl;
        }
    });
});
